import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import { getMMPLUsersDetails } from "../Actions/UserManagementAPI";
import Role from "../helpers/role";

let userRole = localStorage.getItem("UserRoles");

class UsersCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }

  render() {
    const { pageSize, totalRecords, arraylist } = this.props;

    return (
      <div className="" style={{ paddingTop: "12px" }}>
        {this.renderCardData()}
        {arraylist && arraylist.length ? (
          <div className="custom-paginator">
            <Paginator
              className="mb-3"
              first={this.state.first}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card">
                !-- No Items to Display --!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, DeleteUser, hideAdmin } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-2">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-md-9 col-lg-11 col-xl-11 col-sm-9 col-10 col-m-auto"}>
                    <div className="row px-4">
                      <div className={showSidePane ? "col-sm-8" : "col-sm-6"}>
                        <span>
                          <strong>Email : </strong>
                          <span className="italicFont ">{item.mail}</span>
                        </span>
                      </div>
                      {!hideAdmin && (<div className={showSidePane ? "col-sm-4" : "col-sm-6"}>
                        <span>
                          <strong>Is Admin : </strong>
                          <span className="italicFont ">
                            {item.isAdmin ? "True" : "False"}
                          </span>
                        </span>
                      </div>)}
                    </div>
                  </div>
                  {userRole == Role.mmpl ? (<>
                    <div className={"col-sm-3 col-md-2 col-m-auto col-2"}>
                    </div>
                  </>) : (<>
                    <div className={"col-sm-3 col-md-3 col-lg-1 col-xl-1 col-m-auto col-2"}>
                      <div
                        className={showSidePane ? "text-center" : "text-center"}
                      >
                        <i
                          className="fa fa-edit fa-2x fa-lg click p-2"
                          aria-hidden="true"
                          onClick={() => this.ShowSidePanel(item)}
                          style={{ color: " #1a3464" }}
                        ></i>
                        <i
                          className="fa fa-trash-o fa-2x click p-2"
                          aria-hidden="true"
                          style={{ color: " #1a3464" }}
                          onClick={() => DeleteUser(item)}
                        ></i>
                      </div>
                    </div>
                  </>)}
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
  ShowSidePanel = (item) => {
    const id =
      item.specialAccessId ||
      item.mmplId ||
      item.userId;

    this.props.dispatch({ type: "UserDetails", data: item });
    if (this.props.isSpecial) {
      this.props.history.push(`/Home/Management/EditSpecialAccessUser/${id}`);
    } else {
      this.props.history.push(`/Home/Management/EditUser/${id}`);
    }
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UsersCard)
);
